// extracted by mini-css-extract-plugin
export default {"box":"document-download_box__nuHri","icon":"document-download_icon__u5Hp3","text":"document-download_text__vECLW","button":"document-download_button__5Tz9A"};